import Cookie from './Cookie'
import { SapLoginInfo } from './SapUtil'

export default class UidSetCookie {
  private cookie = new Cookie()

  /**
   * 認証用Cookieをセットする
   */
  public setUid(info: SapLoginInfo): void {
    const cookieLimit = 60
    this.cookie.setCookie('UID', info.UID, cookieLimit)
    this.cookie.setCookie('UIDSignature', info.UIDSignature, cookieLimit)
    this.cookie.setCookie(
      'signatureTimestamp',
      info.signatureTimestamp,
      cookieLimit
    )
  }

  /**
   * 認証用Cookieを削除する
   */
  public unSetUid(): void {
    this.cookie.setCookie('UID', '', -1)
    this.cookie.setCookie('UIDSignature', '', -1)
    this.cookie.setCookie('signatureTimestamp', '', -1)
  }

  /**
   * 認証用Cookieを保持しているかを判定する
   */
  public hasCookie(): boolean {
    return (
      this.cookie.get('UID').length > 0 &&
      this.cookie.get('UIDSignature').length > 0 &&
      this.cookie.get('signatureTimestamp').length > 0
    )
  }
}
